import { useEffect, useState } from 'react';

/** A value that follows `value` after it has been still for `delayMs`: search boxes ask the server once the person pauses typing. */
export function useDebounced<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
